import React, { useState } from 'react';
import { AddSkillModal } from '../AddSkillModal';
import './AddSkillButton.css';
import { useTranslation } from 'react-i18next';

export const AddSkillButton = ({ skillType, skillsData, refreshSkills }) => {
  const [isModalOpen, setModalOpen] = useState(false);
  const { t } = useTranslation('library');

  return (
    <>
      <div
        className="div-block-475 add_skill"
        onClick={() => setModalOpen(true)}
      >
        <img
          src="/images/plus_1plus.png"
          loading="lazy"
          alt=""
          className="image-152 add_sk"
        />
        <div className="text-block-284 add_skill_text">{t('Add Skill')}</div>
      </div>

      {isModalOpen && (
        <AddSkillModal
          closeModal={() => setModalOpen(false)}
          skillType={skillType}
          skillsData={skillsData}
          refreshSkills={refreshSkills}
        />
      )}
    </>
  );
};
